import * as Blockly from "blockly";
import { zrCppGenerator } from "./zrCppGenerator";


/* =========================================================
 * SPS / ZONE
 * ========================================================= */

zrCppGenerator.forBlock["zrms17_dropSPSBool"] = function (block, generator) {
    return [
        "game.getNumGeysers()",
        generator.ORDER_FUNCTION_CALL
    ];
};


zrCppGenerator.forBlock["zrms17_dropSPSVoid"] = function (block, generator) {
    const playerId = block.getFieldValue("playerID");

    if (parseInt(playerId, 10) === 0) {
        return [
            "game.getScore()",
            generator.ORDER_FUNCTION_CALL
        ];
    }

    return [
        "game.getOtherScore()",
        generator.ORDER_FUNCTION_CALL
    ];
};


zrCppGenerator.forBlock["zrms17_getNumSPSHeld"] = function (block, generator) {
    return [
        "game.getNumSPSHeld()",
        generator.ORDER_FUNCTION_CALL
    ];
};


zrCppGenerator.forBlock["zrms17_getZone"] = function (block, generator) {
    const zoneInfo = generator.valueToCode(
        block,
        "zoneInfo",
        generator.ORDER_NONE
    );

    return [
        `game.getZone(${zoneInfo})`,
        generator.ORDER_FUNCTION_CALL
    ];
};


/* =========================================================
 * DOCK / DROP
 * ========================================================= */

zrCppGenerator.forBlock["zrms17_dockItem"] = function (block, generator) {
    return "game.dockItem();\n";
};


zrCppGenerator.forBlock["zrms17_dockItemID"] = function (block, generator) {
    const itemId = block.getFieldValue("itemID");

    return [
        `game.dockItem(${itemId})`,
        generator.ORDER_FUNCTION_CALL
    ];
};


zrCppGenerator.forBlock["zrms17_dockItemIDVoid"] = function (
    block,
    generator
) {
    const itemId = block.getFieldValue("itemID");

    return `game.dockItem(${itemId});\n`;
};


zrCppGenerator.forBlock["zrms17_dropItem"] = function (
    block,
    generator
) {
    return "game.dropItem();\n";
};


/* =========================================================
 * ITEM INFO
 * ========================================================= */

zrCppGenerator.forBlock["zrms17_getItemLoc"] = function (
    block,
    generator
) {
    const itemId = block.getFieldValue("itemID");

    const pos = generator.valueToCode(
        block,
        "pos",
        generator.ORDER_NONE
    );

    return `game.getItemLoc(${pos}, ${itemId});\n`;
};


zrCppGenerator.forBlock["zrms17_itemInZone"] = function (
    block,
    generator
) {
    const itemId = block.getFieldValue("itemID");

    return [
        `game.itemInZone(${itemId})`,
        generator.ORDER_FUNCTION_CALL
    ];
};


zrCppGenerator.forBlock["zrms17_isFacingCorrectItemSide"] = function (
    block,
    generator
) {
    const itemId = block.getFieldValue("itemID");

    return [
        `game.isFacingCorrectItemSide(${itemId})`,
        generator.ORDER_FUNCTION_CALL
    ];
};


zrCppGenerator.forBlock["zrms17_hasItem"] = function (
    block,
    generator
) {
    const itemId = block.getFieldValue("itemID");

    return [
        `game.hasItem(${itemId})`,
        generator.ORDER_FUNCTION_CALL
    ];
};


zrCppGenerator.forBlock["zrms17_checkHaveItem"] = function (
    block,
    generator
) {
    const itemId = block.getFieldValue("itemID");
    const playerId = block.getFieldValue("playerID");

    return [
        `(game.hasItem(${itemId}) == ${playerId})`,
        generator.ORDER_FUNCTION_CALL
    ];
};


/* =========================================================
 * OTHER
 * ========================================================= */

zrCppGenerator.forBlock["zrms17_getScore"] = function (
    block,
    generator
) {
    const playerId = block.getFieldValue("playerID");

    if (parseInt(playerId, 10) === 0) {
        return [
            "game.getScore()",
            generator.ORDER_FUNCTION_CALL
        ];
    }

    return [
        "game.getOtherScore()",
        generator.ORDER_FUNCTION_CALL
    ];
};


zrCppGenerator.forBlock["zrms17_getFuelRemaining"] = function (
    block,
    generator
) {
    return [
        "game.getFuelRemaining()",
        generator.ORDER_FUNCTION_CALL
    ];
};